import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  Paper,
  TextField,
  Typography
} from '@material-ui/core';
import { ASIM } from 'consts';
import api from 'services/api';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import GrupoMsgWhatsAppPassageiroForm from './GrupoMsgWhatsAppPassageiroForm';
import React, { useCallback, useEffect, useState } from 'react';

const ROTA_GRUPOS = '/crm/whatsapp/grupos';

const ESTILO_LISTA = {
  maxHeight: 360,
  overflowY: 'auto',
  border: '1px solid #ddd'
};

export default function GrupoMsgWhatsAppPassageiroList({
  modal = false,
  open = true,
  onClose,
  onChanged
}) {
  const history = useHistory();

  const [itens, setItens] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [mostrarInativos, setMostrarInativos] = useState(false);
  const [cadastro, setCadastro] = useState(null);
  const [erro, setErro] = useState('');

  /* Carrega os grupos */
  const carregar = useCallback(async () => {
    const { data } = await api.get(ROTA_GRUPOS);

    setItens(Array.isArray(data) ? data : []);
  }, []);

  /* Carrega os dados iniciais da tela */
  useEffect(() => {
    if (open) {
      carregar().catch(() => setErro('Não foi possível consultar os registros!'));
    }
  }, [open, carregar]);

  /* Abre o cadastro (modal) ou navega para a tela de cadastro */
  const editar = (item) => {
    if (modal) {
      setCadastro(item || {});
    } else {
      history.push(`${ROTA_GRUPOS}/${item ? item.idgrupomsgwhats : 'novo'}`);
    }
  };

  /* Atualiza a lista após salvar o grupo */
  const salvo = async () => {
    await carregar();

    if (onChanged) onChanged();

    setCadastro(null);
  };

  /* Clicar para alterar o grupo */
  const onClickAlterar = (item) => (event) => {
    event.stopPropagation();

    editar(item);
  };

  /* Clicar para incluir um novo grupo */
  const onClickNovo = () => {
    editar(null);
  };

  /* Fecha o cadastro (modal) */
  const onCloseCadastro = () => {
    setCadastro(null);
  };

  /* Evento onChange dos componentes */
  const onChangeFiltro = (event) => setFiltro(event.target.value);
  const onChangeMostrarInativos = (event) => setMostrarInativos(event.target.checked);

  const textoFiltro = filtro.toLowerCase();

  const itensFiltrados = itens.filter(x => (
    (mostrarInativos || x.inativo !== ASIM) &&
    `${x.idgrupomsgwhats} ${x.nome || ''}`.toLowerCase().includes(textoFiltro)
  ));

  const conteudo = (
    <>
      {erro && (
        <Typography color="error">
          {erro}
        </Typography>
      )}

      <Box
        display="flex"
        alignItems="center"
        mb={2}
      >
        <TextField
          fullWidth
          label="Pesquisar por código ou descrição"
          value={filtro}
          onChange={onChangeFiltro}
        />

        <Box ml={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={onClickNovo}
          >
            Novo
          </Button>
        </Box>
      </Box>

      <List
        dense
        style={ESTILO_LISTA}
      >
        {itensFiltrados.map(x => (
          <ListItem
            button
            key={x.idgrupomsgwhats}
            onClick={() => editar(x)}
          >
            <ListItemText
              primary={`${x.nome} [${x.idgrupomsgwhats}]`}
              secondary={x.inativo === ASIM ? 'Inativo' : 'Ativo'}
            />

            <Button
              size="small"
              onClick={onClickAlterar(x)}
            >
              Alterar
            </Button>
          </ListItem>
        ))}
      </List>

      <FormControlLabel
        label="Mostrar inativos"
        control={
          <Checkbox
            color="primary"
            checked={mostrarInativos}
            onChange={onChangeMostrarInativos}
          />
        }
      />
    </>
  );

  if (modal) {
    return (
      <>
        <Dialog
          open={open}
          onClose={onClose}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            Consulta de grupos
          </DialogTitle>

          <DialogContent dividers>
            {conteudo}
          </DialogContent>

          <DialogActions>
            <Button onClick={onClose}>
              Voltar à estrutura
            </Button>
          </DialogActions>
        </Dialog>

        <GrupoMsgWhatsAppPassageiroForm
          modal
          open={cadastro !== null}
          registro={cadastro}
          onClose={onCloseCadastro}
          onSaved={salvo}
        />
      </>
    );
  }

  return (
    <Box p={3}>
      <Paper style={{ padding: 24 }}>
        <Typography
          variant="h6"
          gutterBottom
        >
          Consulta de grupos
        </Typography>

        {conteudo}
      </Paper>
    </Box>
  );
};

GrupoMsgWhatsAppPassageiroList.propTypes = {
  modal: PropTypes.bool,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onChanged: PropTypes.func
};